import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff315e50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-invoice-info-wrap" }


import TitleText from "@/components/common/TitleText.vue";
import ListRow from "@/components/common/list/ListRow.vue";
import IconInvoice from "@/assets/svgs/icon_invoice.svg";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardInvoiceInfo',
  props: {
    companyInvoice: {}
  },
  setup(__props: any) {

const props = __props;



const columns = [
  {
    header: "請求先（宛名）",
    text: props.companyInvoice.invoice_address || '-',
  },
  {
    header: "請求先（To）",
    text: props.companyInvoice.invoice_email || '-',
  },
  {
    header: "請求期日",
    text: props.companyInvoice.labels.invoice_due_date || "-"
  },
  {
    header: "振込期日",
    text: props.companyInvoice.labels.transfer_due_date || "-"
  },
  {
    header: "送付方法",
    text: props.companyInvoice.labels.invoice_shipping_method || "-"
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleText, {
      text: "請求書記載情報",
      "with-icon": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IconInvoice), { class: "icon" })
      ]),
      _: 1
    }),
    _createVNode(ListRow, { columns: columns })
  ]))
}
}

})